export default {
  namespaced: true,
  state: {
    show: false,
    message: '',
    href: '',
    timeout: 0,
    color: undefined
  },
  mutations: {
    show (state, { message, href, timeout, color }) {
      state.show = true
      state.message = message
      state.href = href
      state.timeout = timeout || 0
      state.color = color
    },
    hide (state) {
      state.show = false
      state.message = ''
      state.href = ''
      state.timeout = 0
      state.color = undefined
    },
    setShow (state, value) {
      state.show = value
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/snackbar.js